import { render, staticRenderFns } from "./EventObjectLink.vue?vue&type=template&id=b0282f9a&"
import script from "./EventObjectLink.vue?vue&type=script&lang=js&"
export * from "./EventObjectLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports